import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/yinghui_logo.png'
import _imports_1 from '@/assets/home/img_home_next.png'
import _imports_2 from '@/assets/home/top/img_home_xingzheng.png'
import _imports_3 from '@/assets/home/top/img_home_sifa.png'
import _imports_4 from '@/assets/home/top/img_home_yichang.png'
import _imports_5 from '@/assets/home/top/img_home_sanfang.png'


const _withScopeId = n => (_pushScopeId("data-v-21ba85aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "credit-root hidden-md-and-up" }
const _hoisted_2 = { class: "credit-top margin-top-30" }
const _hoisted_3 = { class: "credit-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-title-text margin-top-20" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "credit-title-top-icon"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "margin-left-10 credit-title-top-text" }, "荧辉数字化服务")
], -1))
const _hoisted_5 = { class: "credit-top-play-text-phone margin-top-20" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-btn-text" }, "了解详情", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "credit-btn-icon margin-left-10"
}, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "credit-content margin-top-15" }
const _hoisted_10 = { class: "credit-item" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"h-start-container\" data-v-21ba85aa><img src=\"" + _imports_2 + "\" class=\"credit-item-title-icon\" data-v-21ba85aa><span class=\"credit-item-title-text margin-left-15\" data-v-21ba85aa>行政处罚</span></div><span class=\"credit-item-text margin-top-20\" data-v-21ba85aa>企业被行政处罚？别忧心！我们的维护服务能迅速处理不良记录影响，还您企业一片清朗信誉天空，助力业务蓬勃发展。</span><span class=\"credit-item-list margin-top-15\" data-v-21ba85aa>① 警告</span><span class=\"credit-item-list margin-top-10\" data-v-21ba85aa>② 处以罚金并且公示</span><span class=\"credit-item-list margin-top-10\" data-v-21ba85aa>③ 没收违法所得</span><span class=\"credit-item-list margin-top-10\" data-v-21ba85aa>④ 撤销正常营业行为</span>", 6)
const _hoisted_17 = { class: "credit-item" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"h-start-container\" data-v-21ba85aa><img src=\"" + _imports_3 + "\" class=\"credit-item-title-icon\" data-v-21ba85aa><span class=\"credit-item-title-text margin-left-15\" data-v-21ba85aa>司法案件</span></div><span class=\"credit-item-text margin-top-20\" data-v-21ba85aa>企业行政处罚维护，争分夺秒！我们以极快速度启动流程，高质量完成维护，让您的企业迅速恢复元气，抢占市场先机。</span><span class=\"credit-item-list margin-top-15\" data-v-21ba85aa>① 合同纠纷</span><span class=\"credit-item-list margin-top-10\" data-v-21ba85aa>② 知识产权纠纷</span><span class=\"credit-item-list margin-top-10\" data-v-21ba85aa>③ 劳动仲裁</span><span class=\"credit-item-list margin-top-10\" data-v-21ba85aa>④ 环境污染纠纷</span>", 6)
const _hoisted_24 = { class: "credit-item" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"h-start-container\" data-v-21ba85aa><img src=\"" + _imports_4 + "\" class=\"credit-item-title-icon\" data-v-21ba85aa><span class=\"credit-item-title-text margin-left-15\" data-v-21ba85aa>历史记录处理</span></div><span class=\"credit-item-text margin-top-20\" data-v-21ba85aa>已结案的诉讼记录、已执行完毕的执行案件记录、行政处罚记录、金融信用记录、负面记录，合法快速处理，不留痕迹。</span><span class=\"credit-item-list margin-top-15\" data-v-21ba85aa>① 诉讼记录</span><span class=\"credit-item-list margin-top-10\" data-v-21ba85aa>② 历史环保处罚记录</span><span class=\"credit-item-list margin-top-10\" data-v-21ba85aa>④ 历史税务处罚记录</span><span class=\"credit-item-list margin-top-10\" data-v-21ba85aa>③ 历史失信被执行人</span>", 6)
const _hoisted_31 = { class: "credit-item" }
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"h-start-container\" data-v-21ba85aa><img src=\"" + _imports_5 + "\" class=\"credit-item-title-icon\" data-v-21ba85aa><span class=\"credit-item-title-text margin-left-15\" data-v-21ba85aa>对接各大平台</span></div><span class=\"credit-item-text margin-top-20\" data-v-21ba85aa>专家团队对接公示系统、各省、市的信用信息平台、三方企业信息查询平台，快速合法合规为您处理企业不良记录信息。</span><span class=\"credit-item-list margin-top-15\" data-v-21ba85aa>① 信用中国</span><span class=\"credit-item-list margin-top-10\" data-v-21ba85aa>② 企业信用信息公示系统</span><span class=\"credit-item-list margin-top-10\" data-v-21ba85aa>③ 各省、市的信用信息平台</span><span class=\"credit-item-list margin-top-10\" data-v-21ba85aa>④ 企某查、天某查、启某宝等查询平台</span>", 6)

import {ref, onMounted, computed} from 'vue';
import {AppConfig} from "@/config";
import {isShowQrCodeDialog} from "@/views/data/CommonData";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCreditPhone',
  setup(__props) {

const onBtnClick = () => {
  isShowQrCodeDialog.value = true
}

// let text = "VUEVUEVUE";
let text = "企业信用快速维护";
let displayedText = ref("");
let index = 0;

const displayTextOneByOne = () => {
  if (index < text.length) {
    if (displayedText.value.length >= text.length) {
      displayedText.value = ""
    }
    displayedText.value += text.charAt(index);
    index++;
    setTimeout(displayTextOneByOne, 200);
  } else if (displayedText.value.length === text.length) {
    index = 0;
    setTimeout(displayTextOneByOne, 2000);
  }
}

onMounted(() => {
  displayTextOneByOne();
});

const textColor = computed(() => {
  return 'red'; // 最后几个字的颜色为红色
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedText), (char, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              style: _normalizeStyle({ color: index < _unref(text).length / 2 ? '#2f2f2f' : '#1b57ec' })
            }, _toDisplayString(char), 5))
          }), 128))
        ])
      ]),
      _createElementVNode("div", {
        class: "credit-btn margin-top-20 margin-bottom-20",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onBtnClick()))
      }, _hoisted_8)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", {
          class: "credit-item-list-more margin-top-10",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onBtnClick()))
        }, "更多行政处罚类型")
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("span", {
          class: "credit-item-list-more margin-top-10",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onBtnClick()))
        }, "更多司法案件类型")
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("span", {
          class: "credit-item-list-more margin-top-10",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (onBtnClick()))
        }, "更多历史记录类型")
      ]),
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _createElementVNode("span", {
          class: "credit-item-list-more margin-top-10",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (onBtnClick()))
        }, "更多对接平台类型")
      ])
    ])
  ]))
}
}

})